import React from 'react'

const BubbleLoader = () => <div className={ 'flex items-center w-full h-10' }>
    <div className={ 'react-loader-container' }>
        <div className={ 'react-loader' }/>
    </div>
</div>;

export default BubbleLoader
